import ApprovalIcon from "@mui/icons-material/Approval";
import FacebookIcon from "@mui/icons-material/Facebook";
import FactoryIcon from "@mui/icons-material/Factory";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { AiOutlineMail } from "react-icons/ai";
import { BsStack } from "react-icons/bs";
import { CiLocationOn } from "react-icons/ci";
import { FaLink, FaPhoneAlt, FaLinkedin } from "react-icons/fa";
import { FaRegCircleUser, FaXTwitter } from "react-icons/fa6";
import { SiIssuu } from "react-icons/si";
import { useContext } from "react";
import { AppContext } from "../../../context/AppContext";

const ProfessionalInfo = ({ userDetails }) => {
  const startYear = userDetails.StartYear;
  const yearsOfExp = new Date().getFullYear() - startYear;
  const { profileType } = useContext(AppContext);

  const websiteUrl = userDetails.WebSiteLink || userDetails.WebsiteLink || null;

  return (
    <>
      <div className="grid grid-cols-2 gap-2 lg:px-40 mt-5">
        <div className="p-6 text-gray-300 bg-neutral-900 rounded-lg">
          <h1 className="text-center mb-5 font-semibold">Key Data</h1>
          <ul className="px-10 flex flex-col gap-4 border-blue-gray-50 text-sm">
            <li className="flex items-center gap-4">
              <span className="min-w-[24px] flex items-center justify-center">
                <FaRegCircleUser size={18} />
              </span>
              <p className="font-normal">{userDetails.Industry || "NA"}</p>
            </li>
            <li className="flex items-center gap-4">
              <span className="min-w-[24px] flex items-center justify-center">
                <FactoryIcon style={{ fontSize: 20 }} />
              </span>
              <p className="font-normal">{userDetails.Concentration || "NA"}</p>
            </li>
            {profileType !== "Company" && (
              <li className="flex items-center gap-4">
                <span className="min-w-[24px] flex items-center justify-center">
                  <ApprovalIcon style={{ fontSize: 20 }} />
                </span>
                <p className="font-normal">
                  {userDetails.ProfessionPositionName || "NA"}
                </p>
              </li>
            )}
            <li className="flex items-center gap-4">
              <span className="min-w-[24px] flex items-center justify-center">
                <BsStack size={18} />
              </span>
              <p className="font-normal">{yearsOfExp} years of experience</p>
            </li>
            <li className="flex items-center gap-4 border-t-2 border-gray-50">
              <div className="flex flex-wrap justify-center items-center w-full gap-4 mt-5">
                {userDetails?.SoftwareLogo?.map((logo, index) => (
                  <img
                    key={index}
                    src={logo}
                    alt="software exp"
                    className="w-10 h-10 object-contain"
                  />
                ))}
              </div>
            </li>
          </ul>
        </div>

        <div className="p-6 text-gray-800 bg-gray-100 rounded-lg">
          <h1 className="text-center mb-5 font-semibold">
            Contact Information
          </h1>
          <ul className="px-10 flex flex-col gap-4 text-sm">
            <li className="flex items-center gap-4">
              <span className="min-w-[24px] flex items-center justify-center">
                <FaLink className="text-gray-400" size={16} />
              </span>
              {websiteUrl ? (
                <a
                  href={websiteUrl.startsWith("http") ? websiteUrl : `https://${websiteUrl}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-normal text-blue-600 hover:underline truncate"
                >
                  {websiteUrl}
                </a>
              ) : (
                <p className="font-normal">NA</p>
              )}
            </li>
            <li className="flex items-center gap-4">
              <span className="min-w-[24px] flex items-center justify-center">
                <AiOutlineMail className="text-gray-400" size={16} />
              </span>
              <p className="font-normal">
                {userDetails.ContactEmailAddress || "NA"}
              </p>
            </li>
            <li className="flex items-center gap-4">
              <span className="min-w-[24px] flex items-center justify-center">
                <FaPhoneAlt className="text-gray-400" size={14} />
              </span>
              <p className="font-normal">
                {userDetails.ContactPhoneNumber || "NA"}
              </p>
            </li>
            <li className="flex items-center gap-4">
              <span className="min-w-[24px] flex items-center justify-center">
                <CiLocationOn className="text-gray-600" size={20} />
              </span>
              <p className="font-normal">
                {userDetails?.Country?.countryName || "NA"}
              </p>
            </li>
            <li>
              <div className="text-lg text-gray-500 border-t-2 border-gray-300 mt-5 pt-5">
                <div className="flex flex-wrap justify-center items-center w-full gap-4 cursor-pointer">
                  {userDetails.InstagramIconLink && (
                    <a
                      href={userDetails.InstagramIconLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <InstagramIcon className="w-10 h-10 text-gray-400 hover:text-gray-600 transition-colors" />
                    </a>
                  )}
                  {userDetails.FacebookIconLink && (
                    <a
                      href={userDetails.FacebookIconLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FacebookIcon className="w-10 h-10 text-gray-400 hover:text-gray-600 transition-colors" />
                    </a>
                  )}
                  {(userDetails.LinkedInIconLink || userDetails.LinkedinIconLink) && (
                    <a
                      href={userDetails.LinkedInIconLink || userDetails.LinkedinIconLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaLinkedin className="w-6 h-6 text-gray-400 hover:text-gray-600 transition-colors" />
                    </a>
                  )}
                  {userDetails.YoutubeIconLink && (
                    <a
                      href={userDetails.YoutubeIconLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <YouTubeIcon className="w-10 h-10 text-gray-400 hover:text-gray-600 transition-colors" />
                    </a>
                  )}
                  {userDetails.IssueIconLink && (
                    <a
                      href={userDetails.IssueIconLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Issuu"
                    >
                      <SiIssuu className="w-6 h-6 text-gray-400 hover:text-gray-600 transition-colors" />
                    </a>
                  )}
                  {userDetails.XIconLink && (
                    <a
                      href={userDetails.XIconLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      title="X (Twitter)"
                    >
                      <FaXTwitter className="w-6 h-6 text-gray-400 hover:text-gray-600 transition-colors" />
                    </a>
                  )}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default ProfessionalInfo;
